var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.71387 3.00042H3.42815C2.48138 3.00042 1.71387 3.76793 1.71387 4.71471V14.1433C1.71387 15.0901 2.48138 15.8576 3.42815 15.8576H12.8567C13.8035 15.8576 14.571 15.0901 14.571 14.1433V9.85756M13.3588 1.78824C14.0283 1.11877 15.1137 1.11877 15.7832 1.78824C16.4527 2.45771 16.4527 3.54313 15.7832 4.2126L8.42395 11.5718H5.99958L5.99958 9.14748L13.3588 1.78824Z",
    stroke: "#F8FFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.ad276d1dc33759fb820f92133b1df72f.svg";
export { ForwardRef as ReactComponent };